import styled from '@emotion/styled';
import { ReactComponent as ImageIcon } from 'features/editor/assets/icons/Photo_off.svg';

// eslint-disable-next-line import/prefer-default-export
export const StyledImageIcon = styled(ImageIcon)`
  path {
    fill: ${(props) => props.theme.colors.blackMediumEmphasis};
    fill-opacity: 1;
  }
`;
